export const TEMPLATE_TYPES = {
  FORMAT_A4: 'format-a4',
  SYSTEM: 2,
  USER: 1,
  NULL: 3,
};

export const CERTIFICATE_TYPES = {
  NO_NOMINATIONS_NO_CATEGORIES: 1,
  WITH_NOMINATIONS_NO_CATEGORIES: 2,
  NO_NOMINATIONS_WITH_CATEGORIES: 3,
  WITH_NOMINATIONS_WITH_CATEGORIES: 4,
};

export default {
  TEMPLATE_TYPES,
};
